@let loading = selectIsRunListLoadingSig();
@let rows = rowsSig();
@let viewState = viewStateSig();

@if(loading) {
    <ui-preloader [color]="1"></ui-preloader>
}@else {
    @switch (viewState) {
        @case (viewStates.INITIAL_EMPTY) {
            <ui-no-data [imgSrc]="noData.imgSrc"
                        [title]="noData.title|translate">
            </ui-no-data>
        }
        @case (viewStates.HAS_CONTENT) {
            <ui-dataset-table [data]="rows"
                            [config]="tableConfig"
                            (rowAction)="onRowAction($event)">
            </ui-dataset-table>
        }
    }
}